<template>
  <up-select :clearable="false" multiple collapse-tags v-model="currentValue" :data="data" :key-value="['name', 'id']" @up:select:change="handleChange">
    <template slot="up:item" slot-scope="{ item, $index }">
      <div class="audience-analysis__checkbox">
        <!-- <label class="el-checkbox">
          <input type="checkbox" v-model="item.checked" class="el-checkbox__inner" /> {{ item.name }}
        </label> -->
        <up-checkbox v-model="checkedValue[$index]">{{ item.name }}</up-checkbox>
      </div>
    </template>
  </up-select>
</template>

<script>
import createVModel from 'element-up/src/mixins/createVModel'

const deepClone = obj => {
  let clone = Object.assign({}, obj);
  Object.keys(clone).forEach(
    key => (clone[key] = typeof obj[key] === 'object' ? deepClone(obj[key]) : obj[key])
  );
  return Array.isArray(obj) && obj.length
    ? (clone.length = obj.length) && Array.from(clone)
    : Array.isArray(obj)
      ? Array.from(obj)
      : clone;
};

const equals = (a, b) => {
  if (a === b) return true;
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) return a === b;
  if (a === null || a === undefined || b === null || b === undefined) return false;
  if (a.prototype !== b.prototype) return false;
  let keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;
  return keys.every(k => equals(a[k], b[k]));
};

export default {
  name: 'audience-analysis-select',
  mixins: [createVModel('currentValue')],
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      lastCheckedValue: [],
      checkedValue: [],
    }
  },
  watch: {
    checkedValue: {
      handler (newVal) {
        if (newVal[0]) {
          if (!this.lastCheckedValue[0]) { // 全选
            this.lastCheckedValue = deepClone(newVal)
            this.checkedValue = this.checkedValue.map(v => true)
          } else if (!newVal.slice(1).every(Boolean) && this.lastCheckedValue[0]) { // 取消全选
            this.checkedValue.splice(0, 1, false)
            this.lastCheckedValue = deepClone(newVal)
          }
        } else {
          if (this.lastCheckedValue[0]) { // 全不选
            this.lastCheckedValue = deepClone(newVal)
            this.checkedValue = this.checkedValue.map(v => false)
          } else {
            this.lastCheckedValue = deepClone(newVal)
            if (newVal.slice(1).every(Boolean)) { // 选中所有其他的，需要直接选中全部选项
              this.checkedValue.splice(0, 1, true)
            }
          }
        }
        this.currentValue = this.data.reduce((acc, val, index) => {
          return acc.concat(this.checkedValue[index] ? val.id : [])
        }, [])

        if (equals(this.value, this.currentValue)) return
        this.$emit('input', this.currentValue)
        this.$emit('selected', {
          value: this.currentValue,
          all: this.currentValue.includes('all')
        })
      },
      deep: true
    },
    data (newVal) {
      this.checkedValue = Array.from({ length: newVal.length }).fill(false)
    }
  },
  methods: {
    handleChange (value) { }
  }
}
</script>
